import { LoadingOutlined } from '@ant-design/icons';
import { EditFieldMfe } from '@components/EditFieldMfe/EditFieldMfe';
import { useBaseUser } from '@hooks/queries/useBaseUser';
import { useOrganization } from '@hooks/queries/useOrganization';
import { useProperty } from '@hooks/queries/useProperty';
import { HallOfEntitiesMfe } from '@screens/Organizations/HallOfEntitiesMfe';
import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { Outlet, useOutlet } from 'react-router';

export function PropertyEntry() {
  const outlet = useOutlet();
  const { property } = useProperty();
  const { organization } = useOrganization();
  const { user } = useBaseUser();
  const { t } = useTranslation();

  if (outlet && property && organization && user) {
    return (
      <>
        <Outlet context={{ property, organization, user }} />
        <EditFieldMfe organization={organization} property={property} />
      </>
    );
  }

  if (outlet) {
    return (
      <div className={'w-full h-full flex items-center gap-4 justify-center'}>
        <Spin
          indicator={
            <LoadingOutlined
              style={{ fontSize: 24 }}
              onPointerEnterCapture={undefined}
              onPointerLeaveCapture={undefined}
              spin
            />
          }
        />
        <h3 className="typo typo--title-2">{t('hall.loading_property')}</h3>
      </div>
    );
  }

  return <HallOfEntitiesMfe />;
}
